// AUTHENTICATION
export const LOGIN = "/login";
export const CREATE_PASSWORD = "/create-password"
export const RESET_PASSWORD = "/reset-password"

//DATA
export const DATA_VISUALIZATION = "/data-visualization";
export const ART = "/art";
export const JEWELRY = "/jewelry";